import React from "react";
import { useState } from "react";
import DateHelpers from "../Helper/DateHelpers";
import '../Styles/PersonalInfo.scss';
import '../Styles/CouplesRetreatPersonalInfo.scss';
import InputValidation from "../Helper/InputValidation";

// Personal info form for the Couples Retreat — adds spouse name/birthdate and an email
// address field, drops the emergency contact section. Reuses PersonalInfo.scss so the
// card/heading/button/input styling is pixel-identical to the standard PersonalInfo form.
function CouplesRetreatPersonalInfo({ personalInformation, setPersonalInformation, selectedPage, setSelectedPage, previousPage, nextPage }) {

   const [invalidGenderError, setInvalidGenderError] = useState(false)
   const [invalidFirstNameError, setInvalidFirstNameError] = useState(false)
   const [invalidLastNameError, setInvalidLastNameError] = useState(false)
   const [invalidBirthDate, setInvalidBirthDate] = useState(false)
   const [invalidSpouseFirstNameError, setInvalidSpouseFirstNameError] = useState(false)
   const [invalidSpouseLastNameError, setInvalidSpouseLastNameError] = useState(false)
   const [invalidSpouseBirthDateError, setInvalidSpouseBirthDateError] = useState(false)
   const [invalidStreetAddress, setInvalidStreetAddress] = useState(false)
   const [invalidCity, setInvalidCity] = useState(false)
   const [invalidState, setInvalidState] = useState(false)
   const [invalidZip, setInvalidZip] = useState(false)
   const [invalidZipFormat, setInvalidZipFormat] = useState(false)
   const [invalidPhone, setInvalidPhone] = useState(false)
   const [invalidPhoneFormat, setInvalidPhoneFormat] = useState(false)
   const [invalidEmail, setInvalidEmail] = useState(false)
   const [invalidEmailFormat, setInvalidEmailFormat] = useState(false)

   function CalculateMinimumDate() {
      let minimumDate = DateHelpers.subtractFromDate(new Date(), 100)
      let formattedDate = DateHelpers.getFormattedDate(minimumDate)
      return formattedDate;
   }

   function ValidatePersonalInformation() {
      let isError = false;

      if (personalInformation.gender === "") {
         setInvalidGenderError(true)
         isError = true;
      }
      if (personalInformation.firstName === "") {
         setInvalidFirstNameError(true)
         isError = true
      }
      if (personalInformation.lastName === "") {
         setInvalidLastNameError(true)
         isError = true
      }
      if (personalInformation.birthDate === "") {
         setInvalidBirthDate(true)
         isError = true
      }
      if (personalInformation.spouseFirstName === "") {
         setInvalidSpouseFirstNameError(true)
         isError = true
      }
      if (personalInformation.spouseLastName === "") {
         setInvalidSpouseLastNameError(true)
         isError = true
      }
      if (personalInformation.spouseBirthDate === "") {
         setInvalidSpouseBirthDateError(true)
         isError = true
      }
      if (personalInformation.strAddress === "") {
         setInvalidStreetAddress(true)
         isError = true
      }
      if (personalInformation.city === "") {
         setInvalidCity(true)
         isError = true
      }
      if (personalInformation.state === "") {
         setInvalidState(true)
         isError = true
      }
      if (personalInformation.zip === "") {
         setInvalidZip(true)
         isError = true
      }
      if (personalInformation.zip !== "") {
         const condition = /^(?!00000)\d{5}(?:[-\s](?!0000)\d{4})?$/
         if (condition.test(personalInformation.zip) === false) {
            setInvalidZipFormat(true)
            isError = true
         }
      }
      if (personalInformation.phone === "") {
         setInvalidPhone(true)
         isError = true
      }
      if (personalInformation.phone !== "") {
         const condition = /^\d{3}[ -]?\d{3}[ -]?\d{4}$/
         if (condition.test(personalInformation.phone) === false) {
            setInvalidPhoneFormat(true)
            isError = true
         }
      }
      if (personalInformation.email === "") {
         setInvalidEmail(true)
         isError = true
      }
      if (personalInformation.email !== "") {
         const condition = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
         if (condition.test(personalInformation.email) === false) {
            setInvalidEmailFormat(true)
            isError = true
         }
      }

      if (isError === false) {
         setSelectedPage(nextPage)
      }
   }

   return (
      <div className='personalInfoContent'>
         <form>
            <h2 id='personalInfoTitle'>Personal Info</h2>

            <div className="camperGender">
               {invalidGenderError === true &&
                  <div className="genderError">
                     * Gender is required
                  </div>
               }
               <div className='gender'>
                  <div className="MaleLabel">
                     <label id="male">Male</label>
                  </div>
                  <div className="Male">
                     <input
                        type="radio"
                        value="M"
                        name="fav_language"
                        checked={personalInformation.gender === "M"}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, gender: (e.target.value) })
                           setInvalidGenderError(false)
                        }}
                     />
                  </div>
                  <div className='FemaleLabel'>
                     <label className="female">Female</label>
                  </div>
                  <div className="Female">
                     <input
                        type="radio"
                        value="F"
                        name="fav_language"
                        checked={personalInformation.gender === "F"}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, gender: (e.target.value) })
                           setInvalidGenderError(false)
                        }}
                     />
                  </div>
               </div>
            </div>

            {/* Row 2: First Name, Last Name, Date of Birth */}
            <div className="coupleRetreatRow">
               <div className="coupleRetreatField">
                  {invalidFirstNameError === true &&
                     <div className="firstNameError">
                        * First name is required
                     </div>
                  }
                  <label>First Name:* </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.firstName}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, firstName: (e.target.value) });
                        setInvalidFirstNameError(false)
                     }}
                  />
               </div>
               <div className="coupleRetreatField">
                  {invalidLastNameError === true &&
                     <div className="lastNameError">
                        * Last name is required
                     </div>
                  }
                  <label>Last Name:* </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.lastName}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, lastName: (e.target.value) });
                        setInvalidLastNameError(false)
                     }}
                  />
               </div>
               <div className="coupleRetreatField">
                  {invalidBirthDate === true &&
                     <div className="birthDateError">
                        * Birth date is required
                     </div>
                  }
                  <label>Birthdate:*</label>
                  <input
                     type="date"
                     required
                     min={CalculateMinimumDate()}
                     value={personalInformation.birthDate}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, birthDate: (e.target.value) })
                        setInvalidBirthDate(false)
                     }}
                  />
               </div>
            </div>

            {/* Row 3: Spouse First Name, Spouse Last Name, Spouse Birthdate */}
            <div className="coupleRetreatRow">
               <div className="coupleRetreatField">
                  {invalidSpouseFirstNameError === true &&
                     <div className="spouseFirstNameError">
                        * Spouse first name is required
                     </div>
                  }
                  <label>Spouse First Name:* </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.spouseFirstName}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, spouseFirstName: (e.target.value) });
                        setInvalidSpouseFirstNameError(false)
                     }}
                  />
               </div>
               <div className="coupleRetreatField">
                  {invalidSpouseLastNameError === true &&
                     <div className="spouseLastNameError">
                        * Spouse last name is required
                     </div>
                  }
                  <label>Spouse Last Name:* </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.spouseLastName}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, spouseLastName: (e.target.value) });
                        setInvalidSpouseLastNameError(false)
                     }}
                  />
               </div>
               <div className="coupleRetreatField">
                  {invalidSpouseBirthDateError === true &&
                     <div className="spouseBirthDateError">
                        * Spouse birthdate is required
                     </div>
                  }
                  <label>Spouse Birthdate:*</label>
                  <input
                     type="date"
                     required
                     min={CalculateMinimumDate()}
                     value={personalInformation.spouseBirthDate}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, spouseBirthDate: (e.target.value) })
                        setInvalidSpouseBirthDateError(false)
                     }}
                  />
               </div>
            </div>

            {/* Row 4: Address Line 1, Address Line 2 */}
            <div className="coupleRetreatRow">
               <div className="coupleRetreatField">
                  {invalidStreetAddress === true &&
                     <div className="streetAddressError">
                        * Address is required
                     </div>
                  }
                  <label>Address Line 1:* </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.strAddress}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, strAddress: (e.target.value) })
                        setInvalidStreetAddress(false)
                     }}
                  />
               </div>
               <div className="coupleRetreatField">
                  <label>Address Line 2: </label>
                  <input
                     type="text"
                     value={personalInformation.strAddress2}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, strAddress2: (e.target.value) })
                     }}
                  />
               </div>
            </div>

            {/* Row 5: City, State, Zip */}
            <div className="coupleRetreatRow">
               <div className="coupleRetreatField">
                  {invalidCity === true &&
                     <div className="cityError">
                        * City is required
                     </div>
                  }
                  <label>City:* </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.city}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, city: (e.target.value) })
                        setInvalidCity(false)
                     }}
                  />
               </div>
               <div className="coupleRetreatField">
                  {invalidState === true &&
                     <div className="stateError">
                        * State is required
                     </div>
                  }
                  <label for="state">State: </label>
                  <select
                     value={personalInformation.state}
                     defaultValue={personalInformation.state}
                     onChange={event => {
                        setPersonalInformation({ ...personalInformation, state: (event.target.value) })
                        setInvalidState(false)
                     }}
                     id="state"
                     name="state">
                     <option value="---">---</option>
                     <option value="Alabama">Alabama</option>
                     <option value="Alaska">Alaska</option>
                     <option value="Arizona">Arizona</option>
                     <option value="Arkansas">Arkansas</option>
                     <option value="California">California</option>
                     <option value="Colorado">Colorado</option>
                     <option value="Connecticut">Connecticut</option>
                     <option value="Delaware">Delaware</option>
                     <option value="District of Columbia">District of Columbia</option>
                     <option value="Florida">Florida</option>
                     <option value="Georgia">Georgia</option>
                     <option value="Guam">Guam</option>
                     <option value="Hawaii">Hawaii</option>
                     <option value="Idaho">Idaho</option>
                     <option value="Illinois">Illinois</option>
                     <option value="Indiana">Indiana</option>
                     <option value="Iowa">Iowa</option>
                     <option value="Kansas">Kansas</option>
                     <option value="Kentucky">Kentucky</option>
                     <option value="Louisiana">Louisiana</option>
                     <option value="Maine">Maine</option>
                     <option value="Maryland">Maryland</option>
                     <option value="Massachusetts">Massachusetts</option>
                     <option value="Michigan">Michigan</option>
                     <option value="Minnesota">Minnesota</option>
                     <option value="Mississippi">Mississippi</option>
                     <option value="Missouri">Missouri</option>
                     <option value="Montana">Montana</option>
                     <option value="Nebraska">Nebraska</option>
                     <option value="Nevada">Nevada</option>
                     <option value="New Hampshire">New Hampshire</option>
                     <option value="New Jersey">New Jersey</option>
                     <option value="New Mexico">New Mexico</option>
                     <option value="New York">New York</option>
                     <option value="North Carolina">North Carolina</option>
                     <option value="North Dakota">North Dakota</option>
                     <option value="Northern Marianas Islands">Northern Marianas Islands</option>
                     <option value="Ohio">Ohio</option><option value="Oklahoma">Oklahoma</option>
                     <option value="Oregon">Oregon</option>
                     <option value="Pennsylvania">Pennsylvania</option>
                     <option value="Puerto Rico">Puerto Rico</option>
                     <option value="Rhode Island">Rhode Island</option>
                     <option value="South Carolina">South Carolina</option>
                     <option value="South Dakota">South Dakota</option>
                     <option value="Tennessee">Tennessee</option>
                     <option value="Texas">Texas</option>
                     <option value="Utah">Utah</option>
                     <option value="Vermont">Vermont</option>
                     <option value="Virginia">Virginia</option>
                     <option value="Virgin Islands">Virgin Islands</option>
                     <option value="Washington">Washington</option>
                     <option value="West Virginia">West Virginia</option>
                     <option value="Wisconsin">Wisconsin</option>
                     <option value="Wyoming">Wyoming</option>
                  </select>
               </div>
               <div className="coupleRetreatField">
                  {invalidZip === true &&
                     <div className="zipError">
                        * Zip code is required
                     </div>
                  }
                  {invalidZipFormat === true &&
                     <div className="zipFormatError">
                        * Zip code must be formatted as such: 12345, 12345 6789, or 12345-6789
                     </div>
                  }
                  <label>Zip:* </label>
                  <input
                     type="text"
                     required
                     maxLength={10}
                     value={personalInformation.zip}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, zip: InputValidation.ValidateInputForPhoneAndZipCode(e.target.value) })
                        setInvalidZip(false)
                        setInvalidZipFormat(false)
                     }} />
               </div>
            </div>

            {/* Row 6: Phone, Email */}
            <div className="coupleRetreatRow">
               <div className="coupleRetreatField">
                  {invalidPhone === true &&
                     <div className="phoneError">
                        * Phone number is required
                     </div>
                  }
                  {invalidPhoneFormat === true &&
                     <div className="phoneFormatError">
                        * Phone number must be formatted as such: 1234567890, 123 456 7890, or 123-456-7890
                     </div>
                  }
                  <label>Cell Phone #:* </label>
                  <input
                     type="text"
                     required
                     maxLength={12}
                     value={personalInformation.phone}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, phone: InputValidation.ValidateInputForPhoneAndZipCode(e.target.value) })
                        setInvalidPhone(false)
                        setInvalidPhoneFormat(false)
                     }} />
               </div>
               <div className="coupleRetreatField">
                  {invalidEmail === true &&
                     <div className="emailError">
                        * Email address is required
                     </div>
                  }
                  {invalidEmailFormat === true &&
                     <div className="emailFormatError">
                        * Email address must be a valid email address
                     </div>
                  }
                  <label>Email Address:* </label>
                  <input
                     type="email"
                     required
                     value={personalInformation.email}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, email: (e.target.value) })
                        setInvalidEmail(false)
                        setInvalidEmailFormat(false)
                     }} />
               </div>
            </div>

            <div className="disclaimerPI">
               <>* Fields are required</>
            </div>
         </form>
         {(
            invalidGenderError === true           || invalidFirstNameError === true    ||
            invalidLastNameError === true          || invalidBirthDate === true         ||
            invalidSpouseFirstNameError === true   || invalidSpouseLastNameError === true ||
            invalidSpouseBirthDateError === true   || invalidStreetAddress === true     ||
            invalidCity === true                   || invalidState === true             ||
            invalidZip === true                    || invalidZipFormat === true         ||
            invalidPhone === true                  || invalidPhoneFormat === true       ||
            invalidEmail === true                  || invalidEmailFormat === true) &&
            <div className="personalInfoErrorMessage">
               Please correct the above error(s):
            </div>
         }
         <div className="personalInfoButtonsContainer">
            <div className="personalInfoButtons">
               <div className="personalInfoPreviousButton">
                  <button className='prevButton' onClick={() => setSelectedPage(previousPage)}>
                     Previous
                  </button>
               </div>
               <div className="personalInfoNextButton">
                  <button className="nextButton" onClick={() => ValidatePersonalInformation()}>
                     Next
                  </button>
               </div>
            </div>
         </div>
      </div>
   )
}
export default CouplesRetreatPersonalInfo;
